import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

export interface UserVerificationResponse {
  user_exists: boolean;
  user_email?: string;
  user_name?: string;
  roles?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly API_BASE_URL = environment.apiBaseURL;
  
  constructor(private http: HttpClient) {}
  
  /**
   * Verify if user has access to the application
   * This is currently mocked - replace with actual API call when backend is ready
   */
  verifyUser(email: string): Promise<UserVerificationResponse> {
    // Mock API call - simulating network delay
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        // Mock successful verification for all users
        // TODO: Replace with actual API call to backend
        const mockResponse: UserVerificationResponse = {
          user_exists: true,
          user_email: email,
          user_name: email.split('@')[0],
          roles: ['user']
        };
        
        resolve(mockResponse);
        
        // Uncomment to test unauthorized scenario:
        // reject(new Error('User not authorized'));
      }, 500); // Simulate 500ms API delay
    });
  }
  
  /**
   * Verify user with backend API
   */
  verifyUserWithBackend(email: string): Observable<UserVerificationResponse> {
    return this.http.get<UserVerificationResponse>(
      `${this.API_BASE_URL}/api/verify}`
    );
  }
}
